module.exports = __webpack_public_path__ + "img/download-icon.588b4ce2.svg";